/**
 * Rubina Irfan - Collection Carousel
 * Momentum-based drag-to-scroll (matches Complete the Look pattern)
 */
(function () {
  'use strict';

  function initDragToScroll() {
    var scrollContainers = document.querySelectorAll('.ri-col-carousel__scroll');

    scrollContainers.forEach(function (container) {
      var isDown = false;
      var startX;
      var scrollLeft;
      var velocity = 0;
      var lastX = 0;
      var lastTime = 0;
      var rafId = null;

      function cancelMomentum() {
        if (rafId) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
      }

      function momentumScroll() {
        if (Math.abs(velocity) < 0.5) return;
        container.scrollLeft += velocity;
        velocity *= 0.95;
        rafId = requestAnimationFrame(momentumScroll);
      }

      container.addEventListener('mousedown', function (e) {
        cancelMomentum();
        isDown = true;
        container.classList.add('is-dragging');
        startX = e.pageX;
        scrollLeft = container.scrollLeft;
        lastX = e.pageX;
        lastTime = Date.now();
        velocity = 0;
        e.preventDefault();
      });

      container.addEventListener('mouseleave', function () {
        if (isDown) {
          isDown = false;
          container.classList.remove('is-dragging');
          if (Math.abs(velocity) > 2) rafId = requestAnimationFrame(momentumScroll);
        }
      });

      container.addEventListener('mouseup', function () {
        if (isDown) {
          isDown = false;
          container.classList.remove('is-dragging');
          if (Math.abs(velocity) > 2) rafId = requestAnimationFrame(momentumScroll);
        }
      });

      container.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var currentX = e.pageX;
        var currentTime = Date.now();
        var deltaX = currentX - startX;
        var timeDelta = currentTime - lastTime;
        if (timeDelta > 0) {
          velocity = (currentX - lastX) / timeDelta * 16;
        }
        container.scrollLeft = scrollLeft - deltaX;
        lastX = currentX;
        lastTime = currentTime;
      });

      container.querySelectorAll('img').forEach(function (img) {
        img.addEventListener('dragstart', function (e) { e.preventDefault(); });
      });

      container.addEventListener('wheel', cancelMomentum);
      container.addEventListener('touchstart', cancelMomentum);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDragToScroll);
  } else {
    initDragToScroll();
  }
})();
